<template>
    <div>
        <dictionary-simple-table
        dictionary_link = "/product-materials"
        title = "Lista materiałów"
        :numeral_text = "['materiał', 'materiały', 'materiały']"
        :columns_title = "['name']"
        ></dictionary-simple-table>
    </div>
</template>

<script>
    import DictionarySimpleTable from './DictionarySimpleTable.vue';
    export default {
        components: {
            DictionarySimpleTable
        },
    }
</script>